import { PreloaderHelper } from "shared/helpers";
import { Tutorial } from "shared/services/tutorials/tutorial";
import { Localizer } from "shared/localization";
import { SoundService } from "shared/services/sound.service";
import { TutorailNameSerivce } from "..";
import { LanguageService } from "../language.service";
import { BuildConfig } from "shared/config";
import config from "config";

export class FillBarTutorial {
    public static toggleFillBarTutorial(state: boolean, screen: PIXI.Container): void {
        const prefixes = BuildConfig.getConfig();
        const slides = [
            {
                //@ts-ignore
                img: `${subPath}assets/gif/tut_fill_bar.gif`,
                text: LanguageService.getTranslation('loc_fill_bar_tutorial')
            },
        ]
        const user = JSON.parse(localStorage.getItem('mbny_game_user'));
        const tutorial = document.getElementById('tutorial');
        const closeTutorial = document.getElementById('closeTutorial');
        const startBtn = document.getElementById('startLevel');
        if (!state) {
            screen.visible = true;
            PreloaderHelper.togglePreloader(false);
            tutorial.style.display = 'none';
            return;
        }

        if (user && user.tutorails.fill_bar) {
            SoundService.toggleBgIntro(true, 0.5, true);
            PreloaderHelper.togglePreloader(false);
            screen.visible = true;
            tutorial.style.display = 'none';
        } else {
            document.getElementById('slider_nav').style.display = 'none';
            console.log(slides);

            Tutorial.addContent(slides, screen);
            screen.visible = false;
            tutorial.style.display = 'flex';
            TutorailNameSerivce.changeName('fillBar');
            closeTutorial.addEventListener('click', () => {
                SoundService.toggleBgIntro(true, 0.5, true);
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                user.tutorails.fill_bar = true;
                localStorage.setItem('mbny_game_user', JSON.stringify(user))
                tutorial.style.display = 'none';
                Tutorial.deleteNodes();
                PreloaderHelper.togglePreloader(false);
                screen.visible = true;
                if(!config.guest)Tutorial.saveTutorial(user.tutorails);
            })

            startBtn.addEventListener('click', () => {
                SoundService.toggleBgIntro(true, 0.5, true);
                const user = JSON.parse(localStorage.getItem('mbny_game_user'));
                user.tutorails.fill_bar = true;
                localStorage.setItem('mbny_game_user', JSON.stringify(user));
                tutorial.style.display = 'none';
                Tutorial.deleteNodes();
                PreloaderHelper.togglePreloader(false);
                screen.visible = true;
                if(!config.guest)Tutorial.saveTutorial(user.tutorails);
            })
        }
    }
}